import StudentsTable from './components/IndexTable';

export default StudentsTable;
